import React from 'react'
import LegalNoticesPage from '../parts/pages/LegalNoticesPage'

export default function Contact() {
  return <LegalNoticesPage />
}
